export default "__VITE_ASSET__HaraIjia__"